import React, { useState, useEffect } from "react";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { v4 as uuidv4 } from "uuid";

import { CenterText, Container, TituloGuia } from "./styled";

import "react-tabs/style/react-tabs.css";
import {
  Table,
  Icon,
  Pagination,
  Grid,
  Input,
  Select,
} from "semantic-ui-react";
import swal from "sweetalert";

import { producaov2 } from "../../../services/apis";
import { convertDate } from "../../../utils/Utils";
import SelectStatus from "./SelectStatus";

function AmePedidos() {
  const [pedidos, setPedidos] = useState([]);
  const [filtros, setFiltros] = useState([]);
  const [sucefull, setSucefull] = useState(false);
  const [error, setError] = useState("");
  const [aba, setAba] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("-1");
  const [count, setCount] = useState(1);
  const [hash, setHash] = useState(1);

  useEffect(() => {
    let url = `ame?page=${page}`;
    if (status !== "-1") url += `&status=${status}`;
    if (search !== "" && search.length > 2) url += `&search=${search}`;
    producaov2
      .get("admin/ame/count")
      .then((res) => {
        setCount(res.data.length);
      })
      .catch(() => {
        swal(
          "Ops",
          "Houve um erro ao listar os pedidos feitos pela AME, entre em contato conosco",
          "error"
        );
      });
    producaov2
      .get(url)
      .then((res) => {
        setPedidos(res.data);
        setHash(hash + 1);
      })
      .catch(() => {
        swal(
          "Ops",
          "Houve um erro ao listar os pedidos feitos pela AME, entre em contato conosco",
          "error"
        );
      });
  }, [aba, page, search, status]);

  function render_header_table() {
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            <CenterText>ID Ame</CenterText>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <CenterText>ID Pedido</CenterText>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <CenterText>Curso</CenterText>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <CenterText>Aluno</CenterText>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <CenterText>Data</CenterText>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <CenterText>Status</CenterText>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    );
  }

  function estornoAction(data) {
    const dataAmePay = JSON.parse(data.json);
    const uuidRefund = uuidv4();
    producaov2
      .post(`admin/ame/estorno/${dataAmePay.id}`, {
        refundId: uuidRefund,
        amount: dataAmePay.amount,
      })
      .then((res) => {
        const newDataRefuned = res.data.ameEstorno;
        producaov2
          .post(`admin/ame/changestatus/${data.pedido.id}`, newDataRefuned)
          .then((res) => {
            swal(
              "Pedido estornado!",
              "O pedido foi estornado com sucesso!",
              "success"
            );
          })
          .catch((error) => {
            swal(
              "Erro no estorno",
              "Houve um erro ao alterar os dados do pedido",
              "error"
            );
          });
      })
      .catch((error) => {
        swal("Erro no estorno", "Houve um erro ao estornar o pedido", "error");
      });
  }

  function changeStatusPedido(option, data) {
    if (
      window.confirm(
        "Tem certeza que deseja mudar o pedido para o status selecionado?"
      )
    ) {
      switch (option) {
        case "2":
          estornoAction(data);
          break;
        case "1":
          alert("Só é possível estornar pedidos");
          break;
        case "3":
          alert("Só é possível estornar pedidos");
          break;

        default:
          break;
      }
    }
  }

  function render_table_body(data) {
    const rows = data.map(
      (arr, i) =>
        !(
          arr?.pedido?.status === 0 &&
          JSON.parse(arr?.pedido?.json || "{}")?.pagamento !== "ame"
        ) && (
          <Table.Row key={`item${i}`}>
            <Table.Cell>
              <CenterText>{arr.id}</CenterText>
            </Table.Cell>
            <Table.Cell>
              <CenterText>{arr?.pedido?.id}</CenterText>
            </Table.Cell>
            <Table.Cell>
              <CenterText>{arr?.curso?.titulo}</CenterText>
            </Table.Cell>
            <Table.Cell>
              <CenterText>
                {arr?.pessoa?.nome} - {arr?.pessoa?.email}
              </CenterText>
            </Table.Cell>
            <Table.Cell>
              <CenterText>{convertDate(new Date(arr.data_create))}</CenterText>
            </Table.Cell>
            <Table.Cell>
              <SelectStatus
                statusProps={arr?.pedido?.status}
                changeStatusPedido={(valor, arr) =>
                  changeStatusPedido(valor, arr)
                }
                hashProps={hash}
                arr={arr}
              />
            </Table.Cell>
          </Table.Row>
        )
    );
    return <Table.Body>{rows}</Table.Body>;
  }

  function render_filters() {
    return (
      <>
        <Grid stackable columns={3}>
          <Grid.Column>
            <Input
              fluid
              id="inputSearchPPAS"
              icon={
                search != "" ? (
                  <Icon
                    onClick={() => setSearch("")}
                    name="close"
                    inverted
                    circular
                    link
                  />
                ) : (
                  <Icon
                    onClick={() =>
                      setSearch(
                        document.getElementById("inputSearchPPAS").value
                      )
                    }
                    name="search"
                    inverted
                    circular
                    link
                  />
                )
              }
              placeholder="Nome, email, id do pedido, etc"
            />
          </Grid.Column>
          <Grid.Column>
            <Pagination
              defaultActivePage={1}
              activePage={page}
              onPageChange={(e, f) => setPage(f.activePage)}
              ellipsisItem={{
                content: <Icon name="ellipsis horizontal" />,
                icon: true,
              }}
              firstItem={{
                content: <Icon name="angle double left" />,
                icon: true,
              }}
              lastItem={{
                content: <Icon name="angle double right" />,
                icon: true,
              }}
              prevItem={{ content: <Icon name="angle left" />, icon: true }}
              nextItem={{ content: <Icon name="angle right" />, icon: true }}
              totalPages={Math.ceil(count / 30)}
            />
          </Grid.Column>
          <Grid.Column>
            <Select
              onChange={(e, f) => setStatus(f.value)}
              style={{ textAlign: "center" }}
              placeholder="Status do pedido"
              options={[
                { key: "-1", value: "-1", text: "Todos" },
                { key: "0", value: "0", text: "Pagos" },
                { key: "71", value: "71", text: "Estornado" },
                { key: "70", value: "70", text: "Não pago" },
              ]}
            />
          </Grid.Column>
        </Grid>
      </>
    );
  }

  function projetos_render() {
    return (
      <div>
        <TituloGuia>Painel de gerenciamento dos pedidos da AME</TituloGuia>
        {render_filters()}
        <Table>
          {render_header_table()}
          {render_table_body(pedidos)}
        </Table>
      </div>
    );
  }

  return (
    <>
      <AdminMenu />
      <Container>{projetos_render()}</Container>
    </>
  );
}

export default AmePedidos;
